import { render, staticRenderFns } from "./Agriculture.vue?vue&type=template&id=7b43ff24&scoped=true&"
import script from "./Agriculture.vue?vue&type=script&lang=js&"
export * from "./Agriculture.vue?vue&type=script&lang=js&"
import style0 from "./Agriculture.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Agriculture.vue?vue&type=style&index=1&id=7b43ff24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b43ff24",
  null
  
)

export default component.exports